import { Component } from '@angular/core';
import { BaseMenuComponent } from './base.menu';
import { ModalComponent } from '../modal/modal.component';

@Component({
    templateUrl: './user-list.menu.html',
    standalone: false
})
export class UserListMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
  }
}
